<template>
    <div class="hidden-print-only">
        <v-navigation-drawer v-model="drawer" app>
            <v-list>
                <template v-for="(item, index) in items">
                    <template v-if="item.subItems.length > 0">
                        <v-list-group
                            :key="index"
                            :prepend-icon="item.icon"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        item.title
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <v-list-item
                                v-for="(subItem, subIndex) in item.subItems"
                                :key="subIndex"
                                :to="'/' + subItem.route"
                            >
                                <v-list-item-title>
                                    {{ subItem.title }}
                                </v-list-item-title>
                                <v-list-item-action>
                                    <v-icon>
                                        {{ subItem.icon }}
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-group>
                    </template>
                    <template v-else>
                        <v-list-item :key="index" :to="'/' + item.route">
                            <v-list-item-action>
                                <v-icon>
                                    {{ item.icon }}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-divider :key="`divider-${index}`" />
                </template>

                <v-list-item @click="logout">
                    <v-list-item-action>
                        <v-icon>logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Logout
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app color="teal" dark>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title>{{ appTitle }}</v-toolbar-title>
        </v-app-bar>
    </div>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: 'Hydra Portal',
            drawer: null,
            items: [
                {
                    title: 'Dashboard',
                    icon: 'dashboard',
                    route: '',
                    subItems: ''
                },
                {
                    title: 'Messages',
                    icon: 'message',
                    route: '',
                    subItems: [
                        {
                            title: 'Send Message',
                            icon: 'send',
                            route: 'message/create'
                        },
                        {
                            title: 'View Messages',
                            icon: 'view_list',
                            route: 'message/lookup'
                        }
                    ]
                },
                {
                    title: 'Employees',
                    icon: 'person',
                    route: '',
                    subItems: [
                        {
                            title: 'View Employees',
                            icon: 'view_list',
                            route: 'employee/lookup'
                        }
                    ]
                },
                {
                    title: 'Groups',
                    icon: 'group',
                    route: '',
                    subItems: [
                        {
                            title: 'Add Group',
                            icon: 'group_add',
                            route: 'message-group/create'
                        },
                        {
                            title: 'View Groups',
                            icon: 'view_list',
                            route: 'message-group/lookup'
                        }
                    ]
                }
            ]
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('userLogout');
        }
    }
};
</script>

<style scoped>
@media print {
    .v-content {
        padding: 0 !important;
    }
}
</style>
